// Privacy-friendly analytics, configured at runtime from CMS settings.
// Nothing loads until initAnalytics() runs with real IDs, so an empty
// config means zero third-party scripts (clean by default).

let config = {
  plausible_domain: "",
  meta_pixel_id: "",
  google_ads_id: "",
  google_ads_label: "",
};
let initialized = false;

function injectScript(attrs) {
  const s = document.createElement("script");
  Object.entries(attrs).forEach(([k, v]) => {
    if (k === "text") s.text = v;
    else s.setAttribute(k, v);
  });
  document.head.appendChild(s);
  return s;
}

export function initAnalytics(settings = {}) {
  if (initialized) return;
  config = { ...config, ...settings };
  initialized = true;

  // Plausible (privacy-friendly, honors DNT)
  if (config.plausible_domain) {
    window.plausible =
      window.plausible ||
      function () {
        (window.plausible.q = window.plausible.q || []).push(arguments);
      };
    injectScript({
      defer: "",
      "data-domain": config.plausible_domain,
      src: "https://plausible.io/js/script.js",
    });
  }

  // Meta Pixel
  if (config.meta_pixel_id) {
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = "2.0";
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
    window.fbq("init", config.meta_pixel_id);
    window.fbq("track", "PageView");
  }

  // Google Ads (gtag)
  if (config.google_ads_id) {
    injectScript({
      async: "",
      src: `https://www.googletagmanager.com/gtag/js?id=${config.google_ads_id}`,
    });
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };
    window.gtag("js", new Date());
    window.gtag("config", config.google_ads_id);
  }
}

export function trackEvent(name, props = {}) {
  try {
    if (typeof window.plausible === "function") window.plausible(name, { props });
  } catch (e) {
    /* no-op */
  }
}

// Fired on every primary CTA click so ad platforms can optimize campaigns.
export function fireLead(props = {}) {
  try {
    if (typeof window.fbq === "function") window.fbq("track", "Lead", props);
  } catch (e) {
    /* no-op */
  }
  try {
    if (config.google_ads_id && config.google_ads_label && typeof window.gtag === "function") {
      window.gtag("event", "conversion", {
        send_to: `${config.google_ads_id}/${config.google_ads_label}`,
      });
    }
  } catch (e) {
    /* no-op */
  }
  trackEvent("Lead", props);
}
